<template>
    <v-card class="pt-1 pl-1 mb-5" >
        <v-card-title class="justify-space-between title font-weight-light pl-1" style="text-overflow: ellipsis;">
            <v-avatar tile size="30">
                <v-img :src="activeevent.imgurl" />
            </v-avatar>
            {{product.name}}
        </v-card-title>

        <v-layout row>
            <v-chip small :color="step===1?'indigo darken-2':''" class="right white--text">1</v-chip>
            <v-chip small :color="step===2?'indigo darken-2':''" class="right white--text">2</v-chip>
            <v-chip small :color="step===3?'indigo darken-2':''" class="right white--text">3</v-chip>
            <v-chip small :color="step===4?'indigo darken-2':''" class="right white--text">4</v-chip>
            <v-chip small :color="step===5?'indigo darken-2':''" class="right white--text">5</v-chip>
            <v-chip small :color="step===6?'indigo darken-2':''" class="right white--text">6</v-chip>
        </v-layout>


        <v-window  v-model="step">


            <v-window-item :value="1" style="min-height:450px;">
                <v-layout row wrap pa-1 ma-2  style="border: solid thin lightgray;border-radius:5px;">
                    <v-flex xs12>
                        <v-btn outlined color="indigo darken-2" to="/auth" v-if="!$store.state.loggedIn">Log In to Register</v-btn>
                        <span v-else-if="skus.length===1" class="success--text title">Confirm and NEXT</span>
                        <span v-else-if="activeevent.eventtype==='tourney'"  class="success--text title">Please select a division:</span>
                        <span v-else class="success--text title">Please select one:</span>
                    </v-flex>
                    <v-flex xs12>
                        <v-radio-group v-model="selectedsku" :mandatory="false">
                            <v-radio  v-for="(s) in skus" :label="s.attributes.name +' - $'+s.price/100" :value="s.id" :key="s.id" :disabled="!$store.state.loggedIn"></v-radio>
                        </v-radio-group>
                    </v-flex>
                    <v-flex xs12>
                        <v-btn outlined color="white" class="indigo--text" :disabled="!selectedsku || (step===2 && registrants.length===0)"   v-if="$store.state.loggedIn && step<3 && selectedsku" @click="step++">
                            <span class="hidden-xs-only">next</span>
                            <v-icon class="px-2">fas fa-arrow-right</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
                <hr/>
            </v-window-item>


            <v-window-item :value="2" style="min-height:450px;">
                <v-layout row wrap pa-1 ma-2 mb-2  style="border: solid thin lightgray;border-radius:5px;">
                    <v-flex xs12>
                        <h2 class="subheading font-weight-light">
                            <InfoButton info="help.players" />
                            <span v-if="activeevent.eventtype==='session'">Who are you registering</span>
                            <span v-if="activeevent.eventtype==='camp'">Select camper(s)</span>
                            <span v-if="activeevent.eventtype==='tourney'">Select {{activeevent.teamsize}} Players</span>
                            <span v-if="activeevent.eventtype==='party'">Who will be attending?</span>
                        </h2>
                    </v-flex>
                    <v-flex xs12 v-if="activeevent.eventtype==='tourney'">
                        <h2 class="subheading font-weight-light px-4" >
                            $ {{selectedpricing.price/100}}
                        </h2>
                    </v-flex>
                    <v-flex xs12 v-else>
                        <h2 class="subheading font-weight-light px-4" v-if="selectedathletes">
                            $ {{selectedpricing.price/100*selectedathletes.length}}
                        </h2>
                    </v-flex>
                    <v-flex xs12>
                        <!--<TeamRegistration :event="activeevent" />-->
                        <DoublesCard v-if="selectedathletes.length>0 && activeevent.eventtype==='tourney' && activeevent.teamsize===2" :p1="selectedathletes[0]" :p2="selectedathletes[1]"  />
                        <v-text-field
                                required
                                outlined
                                v-if="activeevent.eventtype==='tourney' && activeevent.teamsize>2"
                                label="Enter Team Name"
                                v-model="teamname"
                        >
                        </v-text-field>
                        <TeamCard v-if="selectedathletes.length>0 && activeevent.eventtype==='tourney'  && activeevent.teamsize>2" :p1="selectedathletes[0]" :p2="selectedathletes[1]" :p3="selectedathletes[2]" :p4="selectedathletes[3]"  />
                        <v-list :key="mykey">
                            <v-list-tile v-for="(a) in myathletes" :key="a.playerurl" @click="">
                                <v-list-tile-avatar>
                                    <img :src="a.profilepic" />
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title>{{a.firstname}} {{a.lastname}}</v-list-tile-title>
                                    <v-list-tile-sub-title>PIN: {{a.pin}}
                                        <v-icon>fas fa-{{a.relationship}}</v-icon>
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-checkbox v-model="registrants" :value="a.partkey" :disabled="disablechecks && !registrants.includes(a.partkey)" ></v-checkbox>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>
                        <v-btn rounded outlined color="indigo darken-2"  @click="newathletedialog=true;" >
                            <v-icon class="pr-2">fa fa-plus</v-icon>
                            Add another
                            <span class="pl-1" v-if="activeevent.eventtype==='session'">Athlete</span>
                            <span class="pl-1" v-if="activeevent.eventtype==='camp'">Camper</span>
                            <span class="pl-1" v-if="activeevent.eventtype==='tourney'">Player</span>
                            <span class="pl-1" v-if="activeevent.eventtype==='party'">Attendee</span>
                        </v-btn>
                        <v-btn color="white" outlined class="indigo--text" :disabled="!selectedsku || (step===2 && registrants.length===0)"   v-if="$store.state.loggedIn && step<3" @click="step++">
                            <span class="hidden-xs-only">next</span>
                            <v-icon class="px-2">fas fa-arrow-right</v-icon>
                        </v-btn>
                    </v-flex>

                    <v-dialog v-model="newathletedialog" max-width="500"  persistent>
                        <NewAthlete  @close="newathletedialog=false,myAthletes()" />
                    </v-dialog>

                </v-layout>
                <hr/>
            </v-window-item>


            <v-window-item :value="3" style="min-height:450px;">
                <v-layout row wrap pa-1 ma-2 mb-2  style="border: solid thin lightgray;border-radius:5px;">
                    <v-flex xs12>
                        <h2 class="title font-weight-light ma-2">You are registering:<span v-if="activeevent.eventtype==='tourney'&& teamname">{{teamname}}</span></h2>
                        <DoublesCard v-if="selectedathletes.length>0 && activeevent.eventtype==='tourney' && activeevent.teamsize===2" :p1="selectedathletes[0]" :p2="selectedathletes[1]"  />
                        <!--<TeamCard v-if="selectedathletes.length>0 && activeevent.eventtype==='tourney'  && activeevent.teamsize>2" :p1="selectedathletes[0]" :p2="selectedathletes[1]" :p3="selectedathletes[2]" :p4="selectedathletes[3]"  />-->
                        <div v-else v-for="a in selectedathletes" :key="a.id" >
                            <v-avatar>
                                <img :src="a.profilepic" />
                            </v-avatar> {{a.firstname}} {{a.lastname}}
                        </div>
                        <div class="pa-2">
                            for {{product.name}} -
                            <div class="subheading font-weight-light" >
                                {{selectedpricingname}}
                            </div>
                            <div class="subheading font-weight-light">
                               on {{activeevent.eventtimes[0].dt}} -
                                <span >${{selectedpricing.price/100*orderitems.quantity}}</span>
                            </div>
                        </div>
                        <v-btn rounded small outlined color="white" class="indigo--text" :loading="settingcheckout" v-if="step===3"  @click="goToCheckout()">
                            <span class="hidden-xs-only">To Checkout & Pay</span>
                            <v-icon>fa fa-arrow-right</v-icon>
                            <v-icon>fas fa-shopping-cart</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
                <hr/>
            </v-window-item>


            <v-window-item :value="4" style="min-height:450px;">
                <v-layout row wrap pa-1 ma-2 mb-2  style="border: solid thin lightgray;border-radius:5px;">
                    <v-flex xs12>
                        <span class="title">{{errormessage}}</span>
                    </v-flex>
                    <v-flex xs12 v-if="!stripecustomer" >
                        <h3>Enter Payment Method</h3>
                        <div class='stripe-card'
                             :class='{ complete }'>
                            <Card
                                    v-if="stripepublickey"
                                    :stripe='stripepublickey'
                                    :options='stripeOptions'
                                    @change='complete = $event.complete'
                            ></Card>
                        </div>
                        <v-btn v-if="$store.state.appdata"  dark
                               class='pay-with-stripe indigo darken-2'
                               @click='createcustomer()'
                               :disabled='!complete'
                               :loading="creatingcustomer">Next</v-btn>
                        <!--<v-btn class='pay-with-stripe' @click='pay' :disabled='!complete'>Pay with credit card</v-btn>-->
                        <!--<v-btn class='pay-with-stripe' @click='addcard' :disabled='!complete'>Add Card</v-btn>-->
                    </v-flex>
                    <v-flex xs12 md7 v-else>
                        <v-radio-group v-model="selectedsource">
                        <v-list>
                            <v-list-tile v-for="s in stripecustomer.sources.data"  :key="s.id" class="pb-2" >
                                <v-list-tile-action>
                                    <v-icon color="blue">
                                        fab fa-cc-{{s.brand}}
                                    </v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        Exp {{s.exp_month}}/{{s.exp_year}}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title>
                                        Ending in {{s.last4}}
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-radio :value="s.id"></v-radio>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>
                        </v-radio-group>
                        <h3>Add Payment Method</h3>
                        <span class="title">{{errormessage}}</span>
                        <div class='stripe-card'
                             :class='{ complete }'>
                            <Card
                                    v-if="stripepublickey"
                                    :stripe='stripepublickey'
                                    :options='stripeOptions'
                                    @change='complete = $event.complete'
                            ></Card>
                        </div>
                        <!--<v-btn v-if="$store.state.appdata"  dark-->
                               <!--class='pay-with-stripe indigo darken-2'-->
                               <!--@click='createcustomer()'-->
                               <!--:disabled='!complete'-->
                               <!--:loading="creatingcustomer">Next</v-btn>-->
                        <!--<v-btn class='pay-with-stripe' @click='pay' :disabled='!complete'>Pay with credit card</v-btn>-->
                        <v-btn class='pay-with-stripe outlined white--text' :loading="loading" color="indigo darken-1" @click='addcard()' :disabled='!complete'>Add Card</v-btn>
                        <v-btn color="white" outlined class="indigo--text" :disabled="!selectedsource"  @click="step++">
                            <span class="hidden-xs-only">next</span>
                            <v-icon class="px-2">fas fa-arrow-right</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
                <hr/>
            </v-window-item>


            <v-window-item :value="5" style="min-height:450px;">
                <v-layout row wrap pa-1 ma-2  style="border: solid thin lightgray;border-radius:5px;">
                    <v-flex xs12>
                        <div v-if="stripecustomer">
                            <div class="title font-weight-light mt-2 indigo--text">
                                {{orderitems.description}}
                            </div>

                            <div class="subheading font-weight-light">
                                We will charge <span class="font-weight-medium">${{selectedpricing.price/100*orderitems.quantity}}</span>
                            </div>
                            <div class="subheading font-weight-light">
                                using your
                                <span class="font-weight-medium"><v-icon>fab fa-cc-{{activesource.brand.toLowerCase()}}</v-icon>
                                {{activesource.brand}} |
                                    {{activesource.exp_month}}/{{activesource.exp_year}}
                                </span>
                            </div>
                            <div class="subheading font-weight-light">
                                ending in <span class="font-weight-medium">{{activesource.last4}}</span>
                            </div>
                        </div>
                        <hr/>
                        <v-btn color="indigo darken-2" class="white--text" @click="createOrder" :loading="ordering">
                            Confirm to Complete Registration
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-window-item>


            <v-window-item :value="6" style="min-height:450px;">
                <v-card>
                    <v-img
                            :src="activeevent.imgurl"
                            class="white--text"
                            height="200px"
                    >
                        <v-container fill-height fluid>
                            <v-layout fill-height>
                                <v-flex xs12 align-end flexbox class="faded pa-3">
                                    <div class="headline">Thank you for registering for {{activeevent.name}}</div>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-img>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <div class="subheading">
                                    Please check you email for more info. Account activity can be found in your
                                    <v-btn text to="/auth" class="indigo--text font-weight-medium">
                                        account
                                    </v-btn>.
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs3 class="text-xs-center">
                                <div class="subheading blue--text">{{month[new Date(activeevent.eventtimes[0].date).getMonth()]}}</div>
                                <div class="title">{{new Date(activeevent.eventtimes[0].date).getDate()}}</div>
                            </v-flex>
                            <v-flex xs9>
                                {{activeevent.caption || activeevent.description}}
                            </v-flex>
                            <v-flex xs12 py-2>
                                <v-icon class="pr-2">fas fa-map-marker-alt</v-icon> {{activeevent.location}}
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <hr class="my-2" />
                                <div class="text-xs-center body-1 font-weight-light" v-for="t in activeevent.eventtimes" :key="t.id+'-'+t.time">
                                    {{t.dt}} - {{t.t}} - {{t.duration/60}} Hr{{(t.duration/60>1)?'s':''}}
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-window-item>


        </v-window>


        <v-toolbar dark style="width:100%;position: fixed;z-index:3;bottom:0;left:0;" v-if="(activeevent.active && activeevent.stripeId)">
            <v-btn text   @click="$emit('cancel'),step=1,selectedathletes=false"><v-icon class="px-2">fas fa-list</v-icon>
                <span class="hidden-xs-only">Event list</span>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text v-if="step<6"  @click="step--" :disabled="step===1"  ><v-icon class="px-2">fas fa-arrow-left</v-icon>
                <span class="hidden-xs-only">Prev</span>
            </v-btn>
            <v-btn text  v-if="step===6"  to="/" >
                <v-icon class="px-2">fas fa-home</v-icon>
                <span class="hidden-xs-only">Home</span>
            </v-btn>
            <v-spacer></v-spacer>
            <!--:disabled="!selectedsku || (step===2 && (registrants.length===0)"-->
            <v-btn color="white" class="indigo--text" :disabled="!selectedsku || (step===2 && (registrants.length===0))"   v-if="$store.state.loggedIn && step!==3" @click="step++">
                <span class="hidden-xs-only">next</span>
                <v-icon class="px-2">fas fa-arrow-right</v-icon>
            </v-btn>
            <v-btn color="white" class="indigo--text"  text v-else-if="step<3" to="auth"  >
                Log In to register
            </v-btn>
            <v-btn color="white" class="indigo--text" :loading="settingcheckout" v-if="step===3"  @click="goToCheckout()">
                <span class="hidden-xs-only">To Checkout & Pay</span>
                <v-icon>fa fa-arrow-right</v-icon>
                <v-icon>fas fa-shopping-cart</v-icon>
            </v-btn>
        </v-toolbar>

    </v-card>
</template>

<script>
    import NewAthlete from "./NewAthlete";
    import { Card, createToken } from 'vue-stripe-elements-plus'
    import EventCard from "./EventCard";
    import InfoButton from "@/components/InfoButton";
    import TeamRegistration from "@/components/registration/TeamRegistration";
    import DoublesCard from "@/components/registration/DoublesCard";
    import TeamCard from "@/components/registration/TeamCard";
    import {
      mapActions
    } from 'vuex'
    export default {
        props:['product','skus','activeevent','apiendpoint','triggerflow'],
        components: {TeamCard, DoublesCard, TeamRegistration, InfoButton, EventCard, NewAthlete,Card},
        name: "EventRegistration",
        data() {
            return {
                /*Options for STRIPE ELEMENTS*/
                stripepublickey:false,
                stripeOptions: {},
                complete: false,
                /*Options for products and pricing*/
                selectedsku:false,
                selectedpricing:false,
                selectedpricingname:'',
                selectedathletes:false,
                step:1,
                loading:false,
                myathletes:[],
                session:false,
                newathletedialog:false,
                registrants:[],
                settingcheckout:false,
                custId:false, //get from our records or create in Stripe
                appdata:false,
                stripecustomer:false,
                creatingcustomer:false,
                orderitems:[],
                ordering:false,
                myorders:[],
                teamname:'',
                errormessage:'',
                mykey:'',
                month:['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
                disablechecks:false,
                selectedsource:false,
                activesource:false//only for ui purposes
            }
        },
        watch:{
            skus:function(){
                if(this.skus.length===1){
                    this.selectedsku = this.skus[0].id;
                }
                console.log("Selected: ", this.selectedskus)
            },
            triggerflow:function(){
                // if(this.triggerflow===false)return;
                // let em = this;
                // setTimeout(function(){em.step=1},820)
            },
            step:function(){
                switch(this.step){
                    case 1:
                        //trigger tis
                        break;
                    case 2:
                        this.stripePricing();
                        if(this.myathletes.length===0){
                            this.newathletedialog=true;
                        }
                        break;
                    case 3:
                        this.getSelectedAthletes();
                        break;
                    case 4:
                        this.getCustomer()
                        this.setSelectedAthletes()
                        break;
                    case 5:

                        break;
                    case 6:

                    default:
                        break;
                }
            },
            registrants:'getSelectedAthletes',
            selectedsource:function(){
               let em=this;
               this.stripecustomer.sources.data.forEach(function(s){
                   if(em.selectedsource===s.id){
                       em.activesource = s
                   }
               })
            }
        },
        async mounted() {
            //refresh credentials to make sure.. this needs to be attached to the $store
            let em = this;
            em.mykey = new Date().getTime()
            this.myAthletes()
            this.getStripePublicKey()
        },
        methods: {
          ...mapActions(['post',  'get', 'delete', 'put']),
            async createcustomer () {
                //will create customer if needed, then add a card.
                let em = this;
                em.creatingcustomer=true;
                let token = await createToken().then(data => {
                    console.log("stripe data: ", data);
                    if(data.error){
                        em.creatingcustomer=false;
                        em.errormessage = data.error.message;
                        em.complete = false;
                        return false;
                    } else {
                        return data.token.id;
                    }
                })
                if(!token)return;
                console.log("token",token);
                let headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Pool':em.$store.state.user.pool.userPoolId,
                    'Authorization':'Bearer ' + em.$store.state.session.accessToken.jwtToken,
                    'orgkey': em.$store.state.orgkey
                };

                let data = {
                    stripeToken:token,
                    email:em.$store.state.user.attributes.email,
                    metadata:em.$store.state.user.attributes
                }
                let args = {
                    headers:headers,
                    method:'POST',
                    body:JSON.stringify(data)
                };
                fetch(this.apiendpoint+'api/payments/stripe/customer',args)
                    .then((response) => response.json())
                    .then((response) => {
                        console.log(response)
                        if(response.type==='StripeCardError'){
                            em.creatingcustomer=false;
                            em.errormessage = response.message;
                            em.complete = false;
                            return false;
                        } else {
                            if(response.id){
                                //wait for aws to set
                                // the stripe id into our appdata
                              setTimeout(function(){
                                  em.$store.dispatch('getAuth')
                              },1000)
                              setTimeout(function(){
                                  em.getCustomer()
                                  em.creatingcustomer=false;
                                  em.step++
                              },2200)
                            }
                        }
                    }).catch(e=>{
                        res.json("error",this.apiendpoint,e)
                })
            },
            async addcard () { //will create customer if needed, then add a card.
                let em = this;
                let token = await createToken().then(data => {
                    return data.token.id;
                })
                console.log("token",token);
                let headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Pool':em.$store.state.user.pool.userPoolId,
                    'Authorization':'Bearer ' + em.$store.state.session.accessToken.jwtToken,
                    'orgkey': em.$store.state.orgkey
                };
                em.loading=true;
                let data = {
                    stripeToken:token,
                    custId:this.custId,
                }
                let args = {
                    headers:headers,
                    method:'post',
                    body:JSON.stringify(data)
                };
                fetch(this.apiendpoint+'api/payments/stripe/createsource',args)
                    .then((response) => response.json())
                    .then((response) => {
                        console.log(response)
                        em.getCustomer();
                        em.loading=false;
                    })
            },
            async pay () {
                let em = this;
                let token = await createToken().then(data => {
                    console.log("stripe data: ", data);
                    return data.token;
                })
                console.log("token");
                let headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'orgkey': em.$store.state.orgkey
                };
                let data = {
                    orgkey:em.$store.state.orgkey,
                    stripeToken:token,
                    stripeEmail:'jenny.rosen@example.com',
                    sku:'sku1324'
                }
                let args = {
                    headers:headers,
                    method:'post',
                    body:JSON.stringify(data)
                };
                fetch(this.apiendpoint+'api/payments/stripe/createandcharge',args)
                    .then((response) => response.json())
                    .then((response) => {
                        console.log(response)
                    })
            },
            async myAthletes(){
                let athletes = await this.post({path:'api/register/myathletes',body:{}})
                console.log("myathletes", athletes)
                this.myathletes = athletes
            },
            stripePricing(){
                let em = this;
                this.skus.forEach(function(s){
                    console.log("Skus Iteration: ", s)
                    if(em.selectedsku===s.id){
                        em.selectedpricing = s
                        em.selectedpricingname = s.attributes.name
                    }
                })
            },
            getSelectedAthletes(){
               let em = this;
               em.selectedathletes=[]
               em.myathletes.forEach(function(a){
                    if(em.registrants.includes(a.partkey)){
                        em.selectedathletes.push(a)
                    }
               })
               em.disablechecks=(em.activeevent.eventtype==='tourney'&&em.registrants.length==em.activeevent.teamsize)
            },
            setSelectedAthletes(){
                let em = this;
                let i = 0;
                let ct = em.selectedathletes.length;
                let d = '';
                let qty = 0;

                //em.orderitems=[]
                em.orderitems={
                    "currency": "usd",
                    "parent": em.selectedsku,
                    "quantity": qty,//per tourney
                    "type": "sku"
                };
                em.selectedathletes.forEach(function(a){
                    console.log("Step4: A: ", a, em.activeevent.eventtype)
                    if(em.activeevent.eventtype!=='tourney'){
                        qty++; //increment totals for non-team reaelted events (per player/attendee vs per team
                    } else {
                        qty=1
                    }
                    d += a.firstname + ' ' + a.lastname + ' /';
                    i++;
                    if(i===ct){
                        let d2 = d.slice(0,-1);
                        em.orderitems.description = d2+=' '+em.activeevent.name;
                        em.orderitems.quantity = qty
                        //if(em.$store.state.appdata.Item.stripe)em.step++;
                    }
                })
            },
            goToCheckout(){
                let em = this;
                em.settingcheckout=true
              setTimeout(function(){
                  em.step=4
                  em.settingcheckout=false
              },832)
            },
            setAthlete(e,num){
                console.log("Athlete "+num+":", e)
            },
            createOrder(){ //THIS IS THE ACTUAL PAY FUNCTION
                if(!this.stripecustomer)return;
                let em = this;
                em.ordering=true;
                let headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Pool':em.$store.state.user.pool.userPoolId,
                    'Authorization':'Bearer ' + em.$store.state.session.accessToken.jwtToken,
                    'orgkey': em.$store.state.orgkey
                };
                let data = {
                    custId:this.stripecustomer.id,
                    items:this.orderitems,
                    event:this.activeevent,
                    participants:this.selectedathletes,
                    teamname:this.teamname,
                    source:this.activesource.id
                }
                let args = {
                    headers:headers,
                    method:'post',
                    body:JSON.stringify(data)
                };
                fetch(this.apiendpoint+'api/payments/stripe/createorder',args)
                    .then((response) => response.json())
                    .then((response) => {
                        console.log(response)
                        em.ordering=false;
                        em.step=6
                    }).catch(e=>{em.ordering=false; console.log(e)})
            },
            myOrders(){
                let em = this;
                let headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Pool':em.$store.state.user.pool.userPoolId,
                    'Authorization':'Bearer ' + em.session.accessToken.jwtToken,
                    'orgkey': em.$store.state.orgkey
                };
                let args = {
                    headers:headers,
                    method:'get'
                };
                fetch(this.apiendpoint+'api/payments/stripe/customerorderssql/'+this.custId,args)
                    .then((response) => response.json())
                    .then((response) => {
                        console.log(response)
                        em.myorders = response
                    })
            },
            getStripePublicKey(){
                let em = this;
                let headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'orgkey': em.$store.state.orgkey
                };
                let args = {
                    headers:headers,
                    method:'get'
                };
                fetch(this.apiendpoint+'api/payments/stripe/clienttoken/'+em.$store.state.orgkey,args)
                    .then((response) => response.json())
                    .then((response) => {
                        em.stripepublickey=response
                    })
            },
            getCustomer(){
                let em = this;
                let customer = get({path:'api/payments/stripe/customer'})
                let headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer ' + em.$store.state.session.accessToken.jwtToken,
                    'orgkey': em.$store.state.orgkey
                };
                let args = {
                    headers:headers,
                    method:'get'
                };
                fetch(this.apiendpoint+'api/payments/stripe/customer/'+em.$store.state.appdata.Item.stripe,args)
                    .then((response) => response.json())
                    .then((response) => {
                        if(response==null) return em.stripecustomer=false;
                        console.log(response)
                        em.custId = response.id;
                        em.stripecustomer = response
                        if(!em.selectedsource){
                            em.selectedsource = response.default_source
                        }
                    }).catch(e=>{em.stripecustomer=false})
            },
            getAppData(){
                let em = this;
                let headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Pool':em.$store.state.user.pool.userPoolId,
                    'Authorization':'Bearer ' + em.session.accessToken.jwtToken
                };
                let args = {
                    headers:headers,
                    method:'get'
                };
                fetch(this.apiendpoint+'api/register/appdata',args)
                    .then((response) => response.json())
                    .then((response) => { console.log("AppData: ", response)
                        em.appdata = response
                        em.custId = response.Item.stripe
                    })
            },
            goto2(){
                console.log("GOTO2")
                this.step=2
            },
            testEm(){
                let em = this;
                let headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Pool':em.$store.state.user.pool.userPoolId,
                    'Authorization':'Bearer ' + em.session.accessToken.jwtToken
                };
                let args = {
                    headers:headers,
                    method:'POST'
                };
                fetch(this.apiendpoint+'api/payments/stripe/testemail',args)
                    .then((response) => response.json())
                    .then((response) => {
                        return;
                    })
            }
        }
    }
</script>

<style scoped>
    .outlined{
        border: solid thin lightgray;
        border-radius:5px;
    }
    .stripe-card {
        width: 300px;
        border: 1px solid grey;
        padding:5px;
    }
    .stripe-card.complete {
        border-color: green;
    }
    .faded{
        background-color: rgba(50,50,50,.5);
    }
    a{
        text-decoration: none;
    }
</style>